import React from 'react';
import { PropsWithChildren } from "react"
import { TAccordionHeaderProps } from "types/Components/Common/Accordion"

/**
 * Accordion header element 
 * use with combination of Accordion Layout
 * 
 * @param children
 * @returns 
 */
const AccordionHeader = ({isOpen, setIsOpen, children, options, onClickedHeader}: PropsWithChildren<TAccordionHeaderProps>) => {
    const handleClick: React.MouseEventHandler<HTMLButtonElement> = (e) => {
        e.preventDefault()
        if (!isOpen && onClickedHeader) {
            onClickedHeader();
          }
          setIsOpen((prev) => !prev);
    }

    return <div className={`tw-w-full tw-border-t tw-border-gray`}>
            <button className={`tw-flex tw-items-center tw-w-full tw-text-left
            ${options?.arrowPosition === "left" && "tw-flex-row-reverse"}
            `} type="button" onClick={handleClick}>
                <div className={`tw-w-[calc(100%-40px)] tw-truncate`}>
                    {children}
                </div>
                <span className={`tw-relative tw-p-2 tw-w-[40px] tw-text-center tw-h-full`}>
                    <i className={`fa fa-chevron-${isOpen ? "up" : "down"} tw-text-gray-dark tw-leading-7`}/>
                </span>
            </button>
        </div>
}

export default AccordionHeader